import React from "react";

import UrlIcon from "../icons/call.svg";

const PricingWidget = ({actionProvider}) => {
  const options = [
    { text: "📩 Request a Quote", handler: actionProvider.handleBookDemo, id: 1 },
    { text: "🎥 Book a Demo with our Sales Teamo", handler: actionProvider.handleBookDemo, id: 2 },
  ];

  return (
    <div className="options">
      {/* <p>Qshikshak simplifies school operations by bringing everything—attendance, exams, fees, communication, and more—into one secure platform.</p> */}
      <div className="options-containerF">
          {options.map((option) => {
            return (
              <div
                className="option-itemF"
                onClick={option.handler}
                key={option.id}
              >
                {option.text}
              </div>
            );
          })}
        </div>
    </div>
  );

};

export default PricingWidget;
